/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import AddPropertyStep1 from '../../property/AddPropertyStep1'
import AddPropertyStep2 from '../../property/AddPropertyStep2'
import AddPropertyStep3 from '../../property/AddPropertyStep3'
import AddPropertyStep4 from '../../property/AddPropertyStep4'
import AddPropertyStep5 from '../../property/AddPropertyStep5'
import AddPropertyStep6 from '../../property/AddPropertyStep6'
import {useFormik} from 'formik'
import {Create_New_Property} from '../../property/Property_Api'
import Swal from 'sweetalert2'
import {compose} from '@mui/system'
import ViewLeadStep1 from './ViewLeadStep1'
import ViewLeadStep2 from './ViewLeadStep2'
import ViewLeadStep3 from './ViewLeadStep3'
import ViewLeadStep4 from './ViewLeadStep4'
import ViewLeadStep5 from './ViewLeadStep5'
import {getListProperty} from '../../ticketing/TicketingAPI'
import {propertiesDataType} from '../LeadManagementDataTypes'
import {CircularProgress} from '@mui/material'
import {generateLeadFormID} from '../LeadManagementAPI'

// import {addPropertyPropsDataType} from './PropertyDataTypes'
// import {AddPropertyInitialValues} from './PropertyInitialValues'
// import {AddPropertyValidationSchema} from './PropertyValidationSchema'

const modalsRoot = document.getElementById('root-modals') || document.body

const ViewLead = ({
  leads_data_uuid,
  lead_property_details,
  getLeadList,
  show,
  handleClose,
  data,
}: any) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [successMsg, setSuccessMsg] = useState<string | null>(null)
  const [submitBtnLoading, setSubmitBtnLoading] = useState<boolean>(false)
  const [propertyList, setPropertyList] = useState<propertiesDataType[]>()
  const [acceptedProperty, setAcceptedProperty] = useState<any>([])
  const [id, setId] = useState<string | null>(null)
  const [genLeadFormIDLoading, setGenLeadFormIDLoading] = useState<boolean>(false)
  const [successfullySubmitted, setSuccessfullySubmitted] = useState<boolean>(false)
  console.log('IDDDD', id)
  console.log('OOO', lead_property_details)
  console.log('data', data)
  // function to get all properties
  const getPropertyList = async () => {
    try {
      const {data: response} = await getListProperty()
      if (response.code === '200') {
        setPropertyList(response.data)
      } else if (response.code === '204') {
        setPropertyList(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  const handleGenerateLeadFormID = async (leads_property_uuid: string) => {
    setGenLeadFormIDLoading(true)
    try {
      const {data: response} = await generateLeadFormID(leads_property_uuid)
      //   if (modalHeaderRef.current) {
      //     modalHeaderRef.current && modalHeaderRef.current.scrollIntoView()
      //   }
      if (response.code === '200') {
        // setError(null)
        setId(response.data)
      } else {
        setSuccessfullySubmitted(true)
        // setError(
        //     `${response.msg.charAt(0).toUpperCase() + response.msg.slice(1)}: ${response.msg_details}`
        // )
        setId(null)
      }
    } catch (error: any) {
      setError(`Error: ${error}`)
      setId(null)
    } finally {
      setGenLeadFormIDLoading(false)
    }
  }
  // useEffect(() => {
  //     if (acceptedProperty?.length > 0) {
  //         handleGenerateLeadFormID(acceptedProperty[0].leads_property_uuid)
  //     }
  // }, [])
  useEffect(() => {
    getPropertyList()
    if (lead_property_details?.length > 0) {
      const acceptedPropertyArr = lead_property_details.filter(
        (item: any) => item.leads_property_status === 1
      )
      setAcceptedProperty(acceptedPropertyArr)
      // if(acceptedPropertyArr.length > 0){
      //     handleGenerateLeadFormID(acceptedPropertyArr[0].leads_property_uuid)
      // }
    }
  }, [])
  useEffect(() => {
    // if (lead_property_details?.length > 0) {
    setAcceptedProperty(
      lead_property_details.filter((item: any) => item.leads_property_status === 1)
    )
    // }
  }, [lead_property_details])
  useEffect(() => {
    if (acceptedProperty.length > 0 && !id) {
      handleGenerateLeadFormID(acceptedProperty[0].leads_property_uuid)
    }
  }, [acceptedProperty])
  console.log('QQQQQQ', lead_property_details)
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  // function to go to previous step in add property modal
  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
  }

  // function to go to previous step in add property modal
  const nextStep = () => {
    if (!stepper.current) {
      return
    }
    if (stepper.current.getCurrentStepIndex() === 1) {
      if (!checkAddPropertyStep1()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 2) {
      if (!checkAddPropertyStep2()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 3) {
      if (!checkAddPropertyStep3()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 4) {
      if (!checkAddPropertyStep4()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 5) {
      if (!checkAddPropertyStep5()) {
        return
      }
    }
    stepper.current.goNext()
  }

  // formik values for add property form
  //   const formik = useFormik({
  //     initialValues: AddPropertyInitialValues,
  //     validationSchema: AddPropertyValidationSchema,
  //     onSubmit: () => createProperty(),
  //   })

  // submit function for add property form
  //   async function createProperty() {
  //     setSubmitBtnLoading(true)
  //     try {
  //       const {data: res} = await Create_New_Property(
  //         formik.values.property_type_uuid,
  //         formik.values.property_title,
  //         formik.values.carpet_area,
  //         formik.values.carpet_area_unit_uuid,
  //         formik.values.address_1,
  //         formik.values.address_2,
  //         parseInt(formik.values.country_id, 10),
  //         parseInt(formik.values.province_id, 10),
  //         formik.values.city,
  //         parseInt(formik.values.pin_zip, 10),
  //         parseInt(formik.values.current_rent, 10),
  //         formik.values.account_kyc_uuid,
  //         formik.values.isAgent === 'true' ? true : false,
  //         formik.values.owner_name,
  //         formik.values.owner_email_id,
  //         formik.values.owner_contact_number,
  //         formik.values.sub_unit_available === 'true' ? true : false,
  //         parseInt(formik.values.property_usage_type, 10),
  //         parseInt(formik.values.property_furnishing_status, 10),
  //         []
  //       )
  //       if (res.code === '200') {
  //         getProperty()
  //         handleClose()
  //         Swal.fire({
  //           position: 'center',
  //           icon: 'success',
  //           title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
  //           text: res.msg_details,
  //           allowOutsideClick: true,
  //         })
  //       } else {
  //         Swal.fire({
  //           position: 'center',
  //           icon: 'error',
  //           title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
  //           text: res.msg_details,
  //           allowOutsideClick: true,
  //         })
  //       }
  //     } catch (error: any) {
  //       Swal.fire({
  //         position: 'center',
  //         icon: 'error',
  //         title: error,
  //         allowOutsideClick: true,
  //       })
  //     } finally {
  //       setSubmitBtnLoading(false)
  //     }
  //   }

  // function to go to steps onclick of stepper headings
  const handleGoto = (val: number) => {
    let valid: number = 0
    if (val >= 1) {
      if (!checkAddPropertyStep1()) {
        stepper?.current?.goto(1)
        checkAddPropertyStep1()
        return
      } else if (val === 1 && valid === 0) {
        stepper?.current?.goto(1)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 2) {
      if (!checkAddPropertyStep2()) {
        stepper?.current?.goto(2)
        checkAddPropertyStep2()
        return
      } else if (val === 2 && valid === 1) {
        stepper?.current?.goto(2)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 3) {
      if (!checkAddPropertyStep3()) {
        stepper?.current?.goto(3)
        checkAddPropertyStep3()
        return
      } else if (val === 3 && valid === 2) {
        stepper?.current?.goto(3)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 4) {
      if (!checkAddPropertyStep4()) {
        stepper?.current?.goto(4)
        checkAddPropertyStep4()
        return
      } else if (val === 4 && valid === 3) {
        stepper?.current?.goto(4)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 5) {
      if (!checkAddPropertyStep5()) {
        stepper?.current?.goto(5)
        checkAddPropertyStep5()
        return
      } else if (val === 5 && valid === 4) {
        stepper?.current?.goto(5)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val === 6) {
      if (valid === 5) {
        stepper?.current?.goto(6)
        return
      }
    }
    return
  }

  // function to check step1 validations
  const checkAddPropertyStep1 = () => {
    return true
  }
  // function to check step2 validations
  const checkAddPropertyStep2 = () => {
    if (acceptedProperty.length > 0) {
      return true
    } else {
      return false
    }
  }
  // function to check step3 validations
  const checkAddPropertyStep3 = () => {
    if (successfullySubmitted) {
      return true
    } else {
      return false
    }
  }
  // function to check step3 validations
  const checkAddPropertyStep4 = () => {
    return true
  }
  // function to check step4 validations
  const checkAddPropertyStep5 = () => {
    return true
  }

  // wipe out the error every 2 sec
  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }, [error])

  // wipe out the success msg every 2 sec
  useEffect(() => {
    if (successMsg) {
      setTimeout(() => {
        setSuccessMsg('')
      }, 2000)
    }
  }, [successMsg])
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      {/* Begin: Modal header */}
      <div className='modal-header pt-5 pb-5'>
        {/* Begin: Modal Heading */}
        <h2>View Lead</h2>
        {/* End: Modal Heading */}
        {/* Begin::Close button */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close button */}
      </div>
      {/* End: Modal header */}
      {/* Begin: Error msg section */}
      {error && (
        <div className='h-20px d-flex justify-content-center' style={{backgroundColor: 'red'}}>
          <div className='fv-help-block' style={{color: 'white'}}>
            {error}
          </div>
        </div>
      )}
      {successMsg && (
        <div className='h-20px d-flex justify-content-center' style={{backgroundColor: 'green'}}>
          <div className='fv-help-block' style={{color: 'white'}}>
            {successMsg}
          </div>
        </div>
      )}
      {/* End: Error msg section */}
      {/* Begin: Modal body */}
      <div className='modal-body p-5'>
        {/*Begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-row flex-column flex-xl-row flex-row-fluid w-100'
          id='kt_create_account_stepper'
        >
          {/* Begin: Content of the create agreement page */}
          <div>
            {/* begin::Aside*/}
            <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 mb-4'>
              {/* begin::Wrapper*/}
              <div className='card-body px-6 px-lg-10 px-xxl-15 py-5'>
                {/* begin::Nav*/}
                <div className='stepper-nav row'>
                  {/* begin::Step 1*/}
                  <div
                    className='stepper-item current position-relative col-12 col-md-3 row p-0 mb-4'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div
                      className='stepper-wrapper cursor-pointer row w-100'
                      onClick={() => handleGoto(1)}
                    >
                      <div className='d-flex col-md-12 col-3'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>1</span>
                        </div>
                        <div className='d-none d-md-block position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label col-md-12 col-9'>
                        <h3 className='stepper-title'>Add Properties</h3>

                        <div className='stepper-desc fw-semibold fs-8'>Add Properties for Lead</div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                    <div
                      className='stepper-line h-35px col-12 col-md-6 ms-9 d-md-none'
                      style={{borderLeft: 'dotted gray 1px'}}
                    ></div>
                  </div>
                  {/* end::Step 1*/}
                  {/* begin::Step 2*/}
                  <div
                    className='stepper-item position-relative col-12 col-md-3 row p-0'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div
                      className='stepper-wrapper cursor-pointer row w-100'
                      onClick={() => handleGoto(2)}
                    >
                      <div className='d-flex col-md-12 col-3'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>2</span>
                        </div>
                        <div className='d-none d-md-block position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label col-md-12 col-9'>
                        <h3 className='stepper-title'>Schedule Visit</h3>

                        <div className='stepper-desc fw-semibold fs-8'>
                          Schedule Visit and Save Feedback for Properties
                        </div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                    <div
                      className='stepper-line h-35px col-12 col-md-6 ms-9 d-md-none'
                      style={{borderLeft: 'dotted gray 1px'}}
                    ></div>
                  </div>
                  {/* end::Step 2*/}
                  {/* begin::Step 3*/}
                  <div
                    className='stepper-item position-relative col-12 col-md-3 row p-0 mb-4'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div
                      className='stepper-wrapper cursor-pointer row w-100'
                      onClick={() => handleGoto(3)}
                    >
                      <div className='d-flex col-md-12 col-3'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>3</span>
                        </div>
                        <div className='d-none d-md-block position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label col-md-12 col-9'>
                        <h3 className='stepper-title'>Onboard Lead</h3>

                        <div className='stepper-desc fw-semibold fs-8'>
                          Fill the Confirm Booking Form
                        </div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                    <div
                      className='stepper-line h-35px col-12 col-md-6 ms-9 d-md-none'
                      style={{borderLeft: 'dotted gray 1px'}}
                    ></div>
                  </div>
                  {/* end::Step 3*/}
                  {/* begin::Step 4*/}
                  <div
                    className='stepper-item position-relative col-12 col-md-2 row p-0'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div
                      className='stepper-wrapper cursor-pointer row w-100'
                      onClick={() => handleGoto(4)}
                    >
                      <div className='d-flex col-md-12 col-3'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>4</span>
                        </div>
                        <div className='d-none d-md-block position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label col-md-12 col-9'>
                        <h3 className='stepper-title'>Payment</h3>

                        <div className='stepper-desc fw-semibold fs-8'>Generate Payment Link</div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                    <div
                      className='stepper-line h-35px col-12 col-md-6 ms-9 d-md-none'
                      style={{borderLeft: 'dotted gray 1px'}}
                    ></div>
                    {/* begin::Line*/}
                    {/* <div className='stepper-line h-40px'></div> */}
                    {/* end::Line*/}
                  </div>
                  {/* end::Step 4*/}
                  {/* begin::Step 5*/}

                  <div
                    className='stepper-item position-relative col-12 col-md-2 row p-0'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div
                      className='stepper-wrapper cursor-pointer row w-100'
                      onClick={() => handleGoto(5)}
                    >
                      <div className='d-flex col-md-12 col-3'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>5</span>
                        </div>

                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label col-md-12 col-9'>
                        <h3 className='stepper-title'>Completed</h3>

                        <div className='stepper-desc fw-semibold fs-8'>Woah, all done</div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}

                    {/* begin::Line*/}
                    {/* <div className='stepper-line h-40px'></div> */}
                    {/* end::Line*/}
                  </div>
                  {/* end::Step 5*/}
                </div>
                {/* end::Nav*/}
              </div>
              {/* end::Wrapper*/}
            </div>
          </div>

          {/*Begin:: Form Content */}
          <div className='flex-row-fluid px-lg-10'>
            {/*Begin::Form */}
            <div id='kt_modal_create_app_form'>
              {propertyList ? (
                <ViewLeadStep1
                  leads_data_uuid={leads_data_uuid}
                  lead_property_details={lead_property_details}
                  getLeadList={getLeadList}
                  show={show}
                  handleClose={handleClose}
                  propertyList={propertyList}
                  setSuccessMsg={setSuccessMsg}
                  setError={setError}
                  acceptedProperty={acceptedProperty}
                />
              ) : (
                <div
                  className='d-flex justify-content-center align-items-center vh-70'
                  style={{height: '25vh'}}
                >
                  <CircularProgress />
                </div>
              )}
              <ViewLeadStep2
                lead_property_details={lead_property_details}
                setSuccessMsg={setSuccessMsg}
                setError={setError}
                getLeadList={getLeadList}
                setAcceptedProperty={setAcceptedProperty}
                acceptedProperty={acceptedProperty}
              />
              <ViewLeadStep3
                acceptedProperty={acceptedProperty}
                setError={setError}
                getLeadList={getLeadList}
                id={id}
                genLeadFormIDLoading={genLeadFormIDLoading}
                setId={setId}
                setSuccessfullySubmitted={setSuccessfullySubmitted}
                successfullySubmitted={successfullySubmitted}
                data={data}
              />
              <ViewLeadStep4
                acceptedProperty={acceptedProperty}
                setError={setError}
                setSuccessMsg={setSuccessMsg}
              />
              <ViewLeadStep5 />
              {/*Begin::Actions */}
              <div className='d-flex flex-stack pt-4'>
                {/* Begin:: previous button div */}
                <div className='me-2'>
                  {/* Begin:: previous button */}
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                    onClick={prevStep}
                  >
                    Previous
                  </button>
                  {/* End:: previous button */}
                </div>
                {/* End:: previous button div */}
                {/* Begin:: Submit and next button div */}
                <div>
                  {/* Begin:: submit button */}
                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='submit'
                    onClick={handleClose}
                    // disabled={submitBtnLoading}
                  >
                    {/* {submitBtnLoading ? (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Processing...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        ) : ( */}
                    Close
                    {/* )} */}
                  </button>
                  {/* Begin:: submit button */}

                  {/* Begin:: next button */}
                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='next'
                    onClick={nextStep}
                  >
                    Next Step
                  </button>
                  {/* Begin:: next button */}
                </div>
                {/* Begin:: Submit and next button div */}
              </div>
              {/*end::Actions */}
            </div>
            {/*end::Form */}
          </div>
          {/*end:: Form Content */}
        </div>
        {/* end::Stepper */}
      </div>
      {/* End: Modal body */}
    </Modal>,
    modalsRoot
  )
}

export default ViewLead
